import React from "react";
import { useParams, Link } from "react-router-dom";
import { ShieldCheck, BadgeCheck, Wallet, Star, Scale, ArrowLeft } from "lucide-react";
import { Logo } from "../components/Logo";

export function Safety() {
  const items = [
    [ShieldCheck, "Secure Escrow Payment", "Dana kamu ditahan aman oleh BAWAIN dan hanya dilepas ke BAWAINER setelah kamu konfirmasi barang diterima."],
    [BadgeCheck, "Verified Travelers", "BAWAINER melewati verifikasi identitas berlapis: telepon, email, dokumen, dan selfie."],
    [Scale, "Dispute Protection", "Jika ada masalah, buka dispute sebelum order selesai. Tim kami meninjau bukti, chat, dan struk."],
    [Star, "Ratings & Reviews", "Semua review berasal dari order nyata yang selesai. Reputasi tidak bisa dipalsukan."],
    [Wallet, "No Off-Platform Payments", "Jangan pernah membayar di luar BAWAIN. Info pembayaran sensitif otomatis disembunyikan di chat."],
  ];
  return (
    <div className="max-w-2xl space-y-5">
      <h1 className="font-heading font-extrabold text-2xl text-navy flex items-center gap-2"><ShieldCheck className="text-sky" /> BAWAIN Safety Center</h1>
      {items.map(([Icon, t, d], i) => (
        <div key={i} className="bg-white rounded-3xl p-5 shadow-soft border border-black/5">
          <Icon size={24} className="text-navy" />
          <h3 className="font-heading font-bold text-navy mt-2">{t}</h3>
          <p className="text-sm text-muted-foreground mt-1">{d}</p>
        </div>
      ))}
    </div>
  );
}

const LEGAL = {
  terms: ["Terms of Service", "Dengan menggunakan BAWAIN, kamu setuju untuk bertransaksi secara jujur, mematuhi hukum yang berlaku, dan tidak membawa barang terlarang. BAWAIN bertindak sebagai perantara dan penyedia escrow."],
  privacy: ["Privacy Policy", "Kami menghormati privasi kamu. Data pribadi digunakan hanya untuk menjalankan layanan marketplace dan tidak dijual ke pihak ketiga."],
  refund: ["Refund Policy", "Refund tersedia melalui sistem dispute sebelum order selesai otomatis. Dana escrow akan dikembalikan penuh bila BAWAINER gagal membeli/mengantar barang."],
  dispute: ["Dispute Policy", "Buyer dapat membuka dispute untuk barang tidak diterima, salah/rusak, atau berbeda signifikan. Admin meninjau bukti sebelum memutuskan refund atau pelepasan dana."],
  prohibited: ["Prohibited Items", "Dilarang membawa: senjata, narkoba, bahan peledak/mudah terbakar, hewan hidup, barang palsu, uang tunai & logam mulia. Daftar dapat diperbarui admin."],
  agreement: ["BAWAINER Agreement", "Sebagai BAWAINER kamu wajib membeli barang sesuai deskripsi, mengunggah bukti pembelian, dan mengantar barang dengan aman. Komisi 10% dihitung dari biaya jasa."],
  community: ["Community Guidelines", "Bersikaplah sopan, responsif, dan jujur. Dilarang menipu, melakukan pembayaran di luar platform, atau melanggar hukum."],
};

export function Legal() {
  const { doc } = useParams();
  const [title, body] = LEGAL[doc] || ["Document", "Konten akan segera tersedia."];
  return (
    <div className="min-h-screen bg-cloud">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <Link to="/" className="inline-flex items-center gap-2 text-navy font-semibold mb-6"><ArrowLeft size={18} /> <Logo size={26} /></Link>
        <h1 className="font-heading font-extrabold text-3xl text-navy">{title}</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">{body}</p>
        <p className="text-xs text-muted-foreground mt-6">Placeholder document · BAWAIN MVP 2026</p>
      </div>
    </div>
  );
}
